import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 8px 0;
`;

export const OptionContainer = styled.div`
  min-width: 320px;
  padding: 4px 24px;
`;
